import { PopularVideosPage } from "../../modules/Pages";
export var __N_SSP = true;
export default PopularVideosPage;
